const DateTimeOptionTypeEnum = Object.freeze({
    DATE: { value: 'date', text: 'Date' },
    TIME: { value: 'time', text: 'Time' },
    DATE_TIME: { value: 'date-time', text: 'Date and time' },
    DURATION: { value: 'duration', text: 'Duration' },
});

export default DateTimeOptionTypeEnum;
